import { Pill } from '@msaf/core-react'
import { useCallback } from 'react'

export interface PillFilterProps {
  isSkeleton?: boolean
  isEnabled?: boolean
  addValue: () => void
  removeAllValues: () => void
  label: string
}

export function PillFilter({ isSkeleton, isEnabled, addValue, removeAllValues, label }: PillFilterProps) {
  const clickHandler = useCallback(() => {
    if (isEnabled && removeAllValues) {
      removeAllValues()
    } else if (!isEnabled && addValue) {
      addValue()
    }
    // One of the parameters isn't set, don't do anything
  }, [isEnabled, addValue, removeAllValues])

  return <Pill isSkeleton={isSkeleton} handleClick={clickHandler} isSelected={!!isEnabled} label={label} />
}
